import dayjs from 'dayjs';
import advancedFormat from 'dayjs/plugin/advancedFormat';
import customParseFormat from 'dayjs/plugin/customParseFormat';
import localizedFormat from 'dayjs/plugin/localizedFormat';
import minMax from 'dayjs/plugin/minMax';
import updateLocale from 'dayjs/plugin/updateLocale';

import 'dayjs/locale/ru';
import 'dayjs/locale/uk';

dayjs.extend(advancedFormat);
dayjs.extend(customParseFormat);
dayjs.extend(localizedFormat);
dayjs.extend(minMax);
dayjs.extend(updateLocale);

dayjs.updateLocale('ru', {
  monthsShort: 'янв_фев_мар_апр_мая_июн_июл_авг_сен_окт_ноя_дек'.split('_'),
});

dayjs.updateLocale('uk', {
  monthsShort: 'січ_лют_бер_кві_тра_чер_лип_сер_вер_жов_лис_гру'.split('_'),
});

export default dayjs;
